const openTab = (el) => { 
    const tabHeader = document.querySelector(`[data-for="${el}"]`)
    const tabBody = document.querySelector(`[data-tab="${el}"]`)
    const tabHeaders = document.querySelectorAll('.tab__header')
    const tabContents = document.querySelectorAll('.tab__content')

    tabHeaders.forEach(t => t.classList.remove('active'))
    tabContents.forEach(t => t.classList.remove('active'))

    tabHeader.classList.add('active')
    tabBody.classList.add('active')
}